import React, { useEffect, useState, useRef } from "react";
import Headers from "@/components/Headers";
import { Evaluation_Detail } from "@/constants/breadcrumb";
import { getEvaluationDetail, audit } from "@/api/operation";
import { useHistory, useParams } from "react-router-dom";
import { Button, Carousel } from "antd";
import BrightLeft from "@/assets/images/left-bright.png";
import BrightRight from "@/assets/images/right-bright.png";
import DarkLeft from "@/assets/images/left-dark.png";
import DarkRight from "@/assets/images/right-dark.png";
import Nan from "@/assets/images/nan.png";
import Nv from "@/assets/images/nv.png";
import Star from "@/assets/images/star.png";
import NotStar from "@/assets/images/not-star.png";
import classnames from "classnames";
import Modal from "./Modal";
import "./index.scss";

const Page = () => {
  const containerRef = useRef(null);

  const carouselRef = useRef(null);

  const history = useHistory();

  const [detail, setDetail] = useState({});

  //当前轮播图的坐标
  const [carouselIndex, setCarouselIndex] = useState(0);

  const [visible, setVisible] = useState(false);

  const [status, setStatus] = useState("approve"); //refuse

  const handleCancel = () => {
    setVisible(false);
    setStatus("approve");
  };

  // //审核
  // const handleConfirm = () => {
  //   let tryGoodsEvaluateId = window.localStorage.getItem("tryGoodsEvaluateId");
  //   audit({
  //     tryGoodsEvaluateId,
  //     state: status === "approve" ? 1 : 2,
  //   }).then((res) => {
  //     if (res.success) {
  //       handleCancel();
  //       fetchList();
  //     }
  //   });
  // };

  const { id } = useParams();

  //详情
  const fetchList = () => {
    getEvaluationDetail({
      tryRecordId: id,
    }).then((res) => {
      if (res.success) {
        const {
          evaluatePics,
          headPortrait,
          nickName,
          gender,
          age,
          skinTexture,
          dimensionScoreList,
          buyBack,
          evaluateContent,
          submitTime,
          state,
        } = res.data;
        setDetail({
          evaluatePics: evaluatePics ? evaluatePics.split(",") : [],
          headPortrait,
          nickName,
          gender,
          skinTexture,
          age,
          dimensionScoreList,
          buyBack,
          evaluateContent,
          submitTime,
          state,
        });
      }
    });
  };

  const handleMove = (direction, disabled) => () => {
    if (disabled) return;
    if (direction == "prev") {
      //上一页
      carouselRef.current.prev();
    } else if (direction == "next") {
      carouselRef.current.next();
    } else {
      carouselRef.current.goTo(direction, true);
    }
  };

  const handleAfterChange = (current) => {
    setCarouselIndex(current);
  };

  useEffect(() => {
    fetchList();
  }, []);

  const {
    evaluatePics = [],
    headPortrait = "",
    nickName = "",
    gender = 0,
    age = 0,
    skinTexture,
    dimensionScoreList = [],
    buyBack = false,
    evaluateContent = "",
    submitTime = "",
    state,
  } = detail;

  const isNotAudit = state === 0;

  return (
    <div className="container operation-evaluation-detail" ref={containerRef}>
      <Headers BreadCrumbData={Evaluation_Detail}></Headers>

      <div className="button-group pt-24 pl-24 pr-24 ">
        <Button onClick={() => history.push("/page/ssry/grantRecord")}>
          返回
        </Button>

        <div>
          {/* {isNotAudit && (
            <Button
              type="danger"
              onClick={() => {
                setStatus("refuse");
                setVisible(true);
              }}
              style={{ marginRight: 10 }}
            >
              不通过
            </Button>
          )}
          {isNotAudit && (
            <Button
              type="primary"
              onClick={() => {
                setStatus("approve");
                setVisible(true);
              }}
            >
              通过发布
            </Button>
          )} */}
          {state === 1 && (
            <div style={{ color: "rgba(82, 177, 125, 1)" }}>测评审核已通过</div>
          )}
          {state === 2 && (
            <div style={{ color: "rgba(255, 52, 69, 1)" }}>测评审核未通过</div>
          )}
        </div>
      </div>

      <div className="mt-16 pt-24 pl-24 pr-24 content bg-white">
        <div className="carousel">
          <div
            className={classnames("carousel-left", {
              disabled: carouselIndex == 0,
            })}
            onClick={handleMove("prev", carouselIndex == 0)}
          >
            {carouselIndex !== 0 && <img src={BrightLeft} />}
            {carouselIndex == 0 && <img src={DarkLeft} />}
          </div>
          <div
            className={classnames("carousel-right", {
              disabled: carouselIndex == evaluatePics.length - 1,
            })}
            onClick={handleMove(
              "next",
              carouselIndex == evaluatePics.length - 1
            )}
          >
            {carouselIndex !== evaluatePics.length - 1 && (
              <img src={BrightRight} />
            )}
            {carouselIndex == evaluatePics.length - 1 && (
              <img src={DarkRight} />
            )}
          </div>
          <Carousel ref={carouselRef} afterChange={handleAfterChange}>
            {evaluatePics.map((pic) => (
              <div>
                <div className="carousel-item">
                  <img src={pic} />
                </div>
              </div>
            ))}
          </Carousel>

          <div className={classnames("carousel-bottom", "mt-16")}>
            {evaluatePics.map((pic, index) => (
              <div
                className={classnames("carousel-bottom-item", {
                  opacity: index !== carouselIndex,
                  current: index === carouselIndex,
                })}
                onClick={handleMove(index)}
              >
                <img src={pic} />
              </div>
            ))}
          </div>
        </div>

        <div className="header mt-16">
          <div className="header-avatar">
            <img src={headPortrait} />
          </div>
          <div className="header-right">
            <div className="header-right-top">
              <div className="nickname">{nickName}</div>
              <div className="grey">|</div>
              <div className="sex">
                <img src={gender === 1 ? Nan : Nv} />
              </div>
            </div>
            <div className="header-right-bottom">
              <div className="age">{age}岁</div>
              <div className=""> | </div>
              <div className="skin">{skinTexture}</div>
            </div>
          </div>
        </div>

        <div className="comments mt-14">
          {dimensionScoreList.map((item) => (
            <div className="comments-item">
              <div className="comments-item-key">{item.key}</div>
              <div className="comments-item-score">
                {new Array(5).fill("").map((_, index) => (
                  <div className="comments-item-score-item">
                    <img src={index > item.score - 1 ? NotStar : Star} />
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className="comments-bottom">
            <div>是否愿意回购</div>
            <div className={classnames({ active: buyBack })}>愿意</div>
            <div className={classnames({ active: !buyBack })}>不愿意</div>
          </div>
        </div>

        <div className="desc mt-16">{evaluateContent}</div>

        <div className="submit">{submitTime}提交</div>

        <div className="line"></div>
      </div>

      {/* <Modal
        visible={visible}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        content={`确定${
          status === "approve" ? "" : "不"
        }通过用户(${nickName})的试用报告？`}
      /> */}
    </div>
  );
};
export default Page;
